import { h, cloneElement } from 'preact';
import { Link } from 'preact-router';
import cx from 'classnames';
import { isVNode } from '../../lib/util';
import { isCurrent, currentSkinTier } from './util';
import style from './style';
import Icon from '../icon';

/**
 * LinkItems are rendered for every nav item type.
 * By default they render the item's 'props.label' or 'props.text' prop.
 * If 'props.icon' is true, then 'props.iconName' will be rendered as an icon if it exists.
 *
 * If the supplied item is a component instance, it will be rendered.
 * If the supplied item is a function, it will be instantiated as a Component.
 * If a linkRenderer function is supplied by the skin (or directly), it will be used to render.
 */
export default function LinkItem({ item, current, skin, useRouter = true, linkRenderer, suppressLink, innerType, type, onLinkItemClick, positionIndex, ...props }) {
	
	let skinTier = currentSkinTier(skin);
	linkRenderer = skinTier.linkRenderer || linkRenderer;
	let isCurrentLink = isCurrent(item, current);


	props.class = cx(style.link, props.class, skinTier.link, isCurrentLink && skinTier.current);

	// Item is a Component instance, clone it with new props.
	if (isVNode(item)) {
		return cloneElement(item, props);
	}
	//Item is a function, instantiate it like a component.
	else if (typeof item === 'function') {
		let LinkType = item;
		return <LinkType suppressLink={suppressLink} onLinkItemClick={onLinkItemClick} isCurrent={isCurrentLink} {...props} />;
	}
	// A linkRenderer was supplied, use it to render the link.
	else if (linkRenderer) {
		return linkRenderer({ item, suppressLink, onLinkItemClick, isCurrent: isCurrentLink, positionIndex, ...props });
	}

	//Decide whether we are using PreactRouter or an 'a' tag.
	let LinkType = (!item.url || !useRouter || item.new_window || (item.url && item.url.match('://')))
		? 'a'
		: Link;
		
	if (item.new_window) {
		props.target = '_blank';
		props.rel = 'noopener noreferrer';
	}
	
	return (
		<LinkType href={!suppressLink && item.url || 'javascript:'} {...props} onClick={onLinkItemClick}>
			{item.icon && (<Icon name={item.iconName} class={style.icon} />)}
			{item.label && item.label || item.text && item.text}
		</LinkType>
	);
}